export const MembersScreenText = {
  inviteMembersCommand: {
    programException: 'An error occurred while inviting this email.',
  },
  errors: {
    memberAlreadyInvited: 'Member is already invited to a team, please use a different email.',
    memberBelongsToDifferentTeam: 'Member already belongs to a different team on Propelio, please ask for use another email.',
  },
} as const
